export const convertMsToMinute = (ms) => {
    return ms / 60000;
}